import { z } from "zod";

// Define the schema using Zod (same as the backend schema)
const phoneregex =
	/^\+?(\d{1,3})?[\s\.\-]?(\(?\d{1,4}\)?)[\s\.\-]?(\d{1,4})[\s\.\-]?(\d{1,4})[\s\.\-]?(\d{1,4})?$/; // Example regex for phone number

const UserValidationSchema = z.object({
	firstName: z.string().min(1, "First name is required").max(255),
	lastName: z.string().min(1, "Last name is required").max(255),
	email: z.string().email("Invalid email format"),
	password: z
		.string()
		.min(8, "Password must be at least 8 characters long")
		.max(25, "Password must be at most 25 characters long")
		.refine((val) => /[A-Za-z]/.test(val), {
			message: "Password must contain at least one letter",
		})
		.refine((val) => /\d/.test(val), {
			message: "Password must contain at least one number",
		}),
	phoneNumber: z
		.string()
		.refine((val) => phoneregex.test(val), {
			message: "Invalid phone number format",
		})
		.optional(),
	role: z.string().min(1).max(255).optional(),
	active: z.boolean().optional(),
	referralSource: z.string().optional(),
});

export default UserValidationSchema;
